module.exports = __webpack_public_path__ + "static/Laser dentistry intraoral after-8f50088aaeafd0d136d2964cd66071c0.jpg";